import { useTranslation } from 'next-i18next';
import { MapPinIcon } from '@heroicons/react/24/outline';
import {
  Avatar, BadgePill, ImageBj, LinkStyled,
} from '@components/common';

const SuccessStoryCard = (props: ApiSchema<'SuccessStoryCandidate'>) => {
  const {
    userName,
    profilePicture,
    occupationName,
    workplaceName,
    workplaceSlug,
    cityName,
    companyLogo,
  } = props;
  const { t } = useTranslation('common');

  return (
    <LinkStyled
      href={`/company-profile/${workplaceSlug}`}
      styling="none"
    >

      <div className="relative w-full py-4 pl-2 pr-6">
        <div className="relative size-full h-80 overflow-hidden rounded">
          <ImageBj
            alt={userName ?? ''}
            src={profilePicture ?? ''}
            imgFolder="success-stories"
            extractImageName
            fill
            priority
            className="object-cover"
            style={{
              imageRendering: '-webkit-optimize-contrast',
            }}
          />
        </div>
        <BadgePill
          color="white"
          size="sm"
          className="absolute left-0 top-0 !px-2 !py-1 font-bold dark:bg-surface dark:text-ink"
        >
          {t('bjEvent.candidate-hire.title', { candidateName: userName })}
        </BadgePill>
        <div className="absolute bottom-0 right-0 grid w-4/5 grid-cols-3 gap-4 rounded bg-surface p-4 text-ink">
          <div className="col-span-2 flex flex-col gap-1">
            <h3 className="text-sm font-bold">{occupationName}</h3>
            <p className="truncate text-tiny">{workplaceName}</p>
            <div className="flex items-center gap-2">
              <MapPinIcon className="size-4 shrink-0" />
              <p className="w-0 flex-1 truncate text-tiny">{cityName}</p>
            </div>
          </div>
          <div className="col-span-1 flex items-start justify-center">
            <Avatar
              imgPath={companyLogo}
              imgFolder="employer_logo"
              extractImageName
              name={workplaceName}
              size="md"
              aspectRatio="square-fit"
              rounding="none"
              id={(workplaceName ?? '').charCodeAt(0)}
            />
          </div>
        </div>
      </div>
    </LinkStyled>
  );
};

export default SuccessStoryCard;
